<template>
	<div>
		<div class="row mt-2">
			<div class="col-12 col-sm-12 col-md-12 col-lg-12">
				<nav class="navbar navbar-breadcrumb navbar-expand-md bg-breadcrumb breadcrumb-borde">
					<div class="mr-auto">
                    	<nav aria-label="breadcrumb">
                    	<ol class="breadcrumb clearfix pt-3">
                    	    <li class="breadcrumb-item"><a href="#">Ubicación</a></li>
                    	</ol>
                    	</nav>
                	</div>
					<form class="form-inline d-none d-md-none d-lg-block">
                    	<div class="form-group mt-n2">
                    	<button :disabled="disabled" type="button" @click="Recargar" class="btn btn-info"> 
                    	    <i v-show="disabled" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i> <i class="fa fa-undo"></i> Recargar </button>  
                    	</div>
                	</form>
				</nav>
			</div>
		</div>
		<GmapMap :center="center" :zoom="zoom" ref="gmap" id="gmap" map-type-id="roadmap" :style="'width:'+ pWidth+'; height: 500px'" :mapTypeControl="false" :scaleControl="false" :streetViewControl="false" :rotateControl="false" :fullscreenControl="true" :disableDefaultUi="false">
			<gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @mouseover="toggleInfoWindow(item, index)" @closeclick="infoWinOpen=false">
				<div class="info_content">
                    <h4 class="mb-1">
                        <b-avatar :src="datos.LogoSucursal" size="2rem"></b-avatar> 
                        {{datos.Nombre}} 
                    </h4>
                </div>
			</gmap-info-window>
			<GmapMarker ref="marker" v-for="(item, index) in arreglodinamico" :key="index" :position="item.position" :clickable="true" :draggable="false" :icon="validateicon(item)" @click="toggleInfoWindow(item, index);center=item.position" @mouseover="toggleInfoWindowMouse(item, index);position=item.position"/>
		</GmapMap>
	</div>
</template>

<script>
export default {
	name:'Cubicacion',
	props:['Arreglo','rutasucursal','rutaempresa','pWidth'],
	data() {
		return {
			zoom:2,
			center: {
                lat:19.43441642213732, 
                lng:-99.13307696649245
            },
			infoWindowPos: null,
            infoWinOpen: false,
            currentMidx: null,
			infoContent :'',
            infowindow:'',
            markers: [],
			Puntos:[],
			disabled:true,
			infoOptions: { //optional: offset infowindow so it visually sits nicely on top of our marker
                pixelOffset: {
                    width: 0,
                    height: -35
                }
            },
			datos:{
				Nombre:'',
				LogoSucursal:''
			}
		}
	},
	methods: {
		toggleInfoWindowMouse: function(marker, idx){
			this.typeinfo= 0;
			this.infoWindowPos = marker.position;
			this.infoContent = marker.datos.Nombre
			this.datos.Nombre=marker.datos.Nombre;
			this.datos.LogoSucursal=marker.datos.LogoSucursal;
			//check if its the same marker that was selected if yes toggle
            if (this.currentMidx == idx) {
              this.infoWinOpen = !this.infoWinOpen;
            }
            //if different marker set infowindow to open and reset current marker index
            else {
              this.infoWinOpen = true;
              this.currentMidx = idx;
            }
		},
		toggleInfoWindow: function(marker, idx){
			this.typeinfo= 0;
            this.infoWindowPos = marker.position;
			this.infoContent = marker.datos.Nombre
			this.datos.Nombre=marker.datos.Nombre;
			this.datos.LogoSucursal=marker.datos.LogoSucursal;
			if (this.zoom>17)
            {
              this.zoom=17;
            }
            else if (this.zoom==17)
            {
              this.zoom=16;
            }
            else{
              this.zoom=18;
            }
			if (this.currentMidx == idx) {
            	this.infoWinOpen = !this.infoWinOpen;
            }
			else {
            	this.infoWinOpen = true;
            	this.currentMidx = idx;
            }
		},
		validateicon(item){
			return require('@/style/images/Cliente.png');
		},
		GetPuntos(){
			this.disabled=true;
			this.$http.get('clientesucursalubi/get',{
				params:{
					
				}
			}).then((res)=>{
				this.markers=[];
				let Lista=res.data.data.all.filter((value) => {
					if (parseFloat(value.Latitud)==0 || parseFloat(value.Longitud)==0) {
						return false;
					}
					else{
						return true;
					}
				});
				Lista.forEach((value) => {
					value.lat=parseFloat(value.Latitud);
					value.lng=parseFloat(value.Longitud);
					this.markers.push({
						position: {
							lat: parseFloat(value.Latitud),
							lng: parseFloat(value.Longitud)
						},
						datos:{
							Nombre:value.Nombre,
							LogoSucursal:value.LogoSucursal
						}
					});
				}).finally(()=>{
					this.disabled=false;
				});
				// console.log(this.markers);
				// this.Puntos=Lista;
				// this.markers=Lista;
			})
		},
		Recargar(){
			this.GetPuntos();
		}
	},
	created() {
		this.bus.$off('SetUbicaciones');
		this.bus.$on('SetUbicaciones',()=>{
			this.GetPuntos();
		})
	},
	computed: {
		arreglodinamico() {
            let marcadores =  this.markers;
            // this.markers= this.Arreglo;
        
            // this.ruta=this.rutatrab;
            // setTimeout(this.Boud, 1000); 
            
            return marcadores;
        }
	},
}
</script>

<style>

</style>
